import fetchBasicDetailsFromStorage from '../../common/utils/fetchBasicDetailsFromStorage';
import React, { useEffect } from 'react';
import { BasicDetails } from '../../store/interfaces';
import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import { routeMappings } from '../../constants';
import { RoutePageProps } from '../../base/components/Routes';
import { useBasicDetails } from '../../store/storeApi';
import { useHistory, useLocation } from 'react-router-dom';
import { SessionStore } from '../../constants/sessionStore';

/** Method to redirect to current workflow item or login page conditionally */
const redirectUrlForNonAuthenticatedUser = (basicDetails: BasicDetails): string => {
  const { currentWorkflowItem, userSessionActive } = basicDetails;
  /** userSessionActive has highest priority, then login and after that all the rest */
  let url = routeMappings['NOT_FOUND'];
  if (currentWorkflowItem) {
    url = `${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`;
    if (!userSessionActive) {
      url = routeMappings['LOGIN'];
    }
  }
  return url;
};

/**
 * - HOC Responsible to fetch basic details from sessionstorage
 */
export const withNoAuthentication = <P extends RoutePageProps>(
  Component: React.ComponentType<P>,
): ((props: P) => JSX.Element) => (props: P): JSX.Element => {
  const history = useHistory();
  const location = useLocation();
  const { setBasicDetails } = useBasicDetails();
  const expCookie = getExperienceInitCookie();
  const deadlineDatePassed = (expCookie && expCookie.candidateDeadlinePassed) || false;

  useEffect(() => {
    if (deadlineDatePassed) {
      history.push(routeMappings['EXPIRED']);
      return;
    }

    if (sessionStorage.getItem(SessionStore.currentWorkflowItem) && sessionStorage.getItem(SessionStore.template)) {
      const basicDetails = fetchBasicDetailsFromStorage();
      setBasicDetails(basicDetails);
      if (![routeMappings['FORGOT_PASSWORD']].includes(location.pathname)) {
        history.push(redirectUrlForNonAuthenticatedUser(basicDetails));
      }
    } else {
      // TODO: If we have feature to auto-initialize the workflow session
      history.push(routeMappings['NOT_FOUND']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, location.pathname]);

  return (
    <>
      <React.Suspense fallback={<></>}>
        <Component {...props} />
      </React.Suspense>
    </>
  );
};
